import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from './services/login.service';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { UserDataResponse } from './interfaces/login-data-response.interface';
// AlarmService NICHT mehr injizieren!

@Injectable({
  providedIn: 'root'
})
export class UserResolver {
  constructor(private readonly loginService: LoginService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserDataResponse> {
    // LoginService kümmert sich automatisch um AlarmService via Events
    return this.loginService.getUserViaJwtToken();
  }
}
